import React from 'react';
import { Cell } from 'react-table';

import { IconWrite } from '@trqk/components';

import { useGapAnalysisTools } from '../../../../../../hooks';
import { rowHeight } from '../constants';

interface EditCellProps {
    cell: Cell<TrqkGapSummary, string>;
}

/**
 * Displays a button allowing the user to edit a report in the GapAnalysisReportSummaryTable.
 * @param props - {@link EditCellProps}
 * @returns JSX
 */
export function EditCell({ cell }: EditCellProps): JSX.Element {
    const { value: gapAnalysisId } = cell;
    const { openManageGapAnalysis } = useGapAnalysisTools();

    return (
        <div className="flex items-center" style={{ height: rowHeight }}>
            <button
                type="button"
                onClick={() => {
                    openManageGapAnalysis({
                        gapAnalysisId,
                        mode: 'edit',
                    });
                }}
            >
                <IconWrite width={24} fillColor="primary-500" />
            </button>
        </div>
    );
}
